/**
 * OS ÍCONES DO SISTEMA, num lugar só (20/10). Traço em `currentColor`, sem
 * preenchimento, caixa de 16: a cor e o tamanho vêm de quem usa. Antes cada
 * tela desenhava a própria lupa e a própria seta, com traços diferentes.
 */
import type { ReactNode, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & { tamanho?: number };

function base({ tamanho = 16, ...resto }: Props, desenho: ReactNode, traco = 1.6) {
  return (
    <svg viewBox="0 0 16 16" width={tamanho} height={tamanho} fill="none" stroke="currentColor"
         strokeWidth={traco} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...resto}>
      {desenho}
    </svg>
  );
}

export const IconeLupa = (p: Props) =>
  base(p, <><circle cx="7" cy="7" r="4.6" /><path d="m10.6 10.6 3 3" /></>);
export const IconeSeta = (p: Props) => base(p, <path d="M3 8h10M9 4l4 4-4 4" />, 1.8);
export const IconeVoltar = (p: Props) => base(p, <path d="M13 8H3M7 4 3 8l4 4" />, 1.8);
export const IconeChevron = (p: Props) => base(p, <path d="M4 6l4 4 4-4" />);
export const IconeXis = (p: Props) => base(p, <path d="M4 4l8 8M12 4l-8 8" />);
export const IconeMais = (p: Props) => base(p, <path d="M8 3v10M3 8h10" />);
export const IconeVisto = (p: Props) => base(p, <path d="m3.5 8.5 3 3 6-7" />, 1.8);
export const IconeFunil = (p: Props) => base(p, <path d="M2 3h12L9.5 8.5V13l-3-1.5v-3L2 3Z" />, 1.5);
export const IconeGrade = (p: Props) =>
  base(p, <><rect x="2" y="2" width="5" height="5" rx="1" /><rect x="9" y="2" width="5" height="5" rx="1" />
    <rect x="2" y="9" width="5" height="5" rx="1" /><rect x="9" y="9" width="5" height="5" rx="1" /></>, 1.5);
export const IconeLinhas = (p: Props) => base(p, <path d="M2 3.5h12M2 8h12M2 12.5h12" />, 1.5);
export const IconeLixeira = (p: Props) =>
  base(p, <path d="M3 4.5h10M6.5 4.5V3h3v1.5M4.5 4.5l.6 8.5a1 1 0 0 0 1 .9h3.8a1 1 0 0 0 1-.9l.6-8.5" />, 1.5);
export const IconeInfo = (p: Props) =>
  base(p, <><circle cx="8" cy="8" r="6.2" /><path d="M8 7.2v3.6M8 5.1v.1" /></>, 1.5);
export const IconeAlerta = (p: Props) =>
  base(p, <><path d="M8 2.2 14.3 13H1.7L8 2.2Z" /><path d="M8 6.5v3M8 11.3v.1" /></>, 1.5);
export const IconeCadeado = (p: Props) =>
  base(p, <><rect x="3.5" y="7" width="9" height="6.5" rx="1.2" /><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" /></>, 1.5);
export const IconeDocumento = (p: Props) =>
  base(p, <><path d="M4.5 1.5h5l3 3v9a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1Z" /><path d="M9.5 1.5v3h3" /></>, 1.4);
export const IconeRelogio = (p: Props) =>
  base(p, <><circle cx="8" cy="8" r="6" /><path d="M8 4.8V8l2.2 1.5" /></>, 1.5);
/** Onde fica: o alfinete do mapa. */
export const IconeLocal = (p: Props) =>
  base(p, <><path d="M8 14.2s4.3-4 4.3-7.7a4.3 4.3 0 0 0-8.6 0c0 3.7 4.3 7.7 4.3 7.7Z" /><circle cx="8" cy="6.5" r="1.5" /></>, 1.4);
/** Dinheiro: a moeda com o cifrão. */
export const IconeMoeda = (p: Props) =>
  base(p, <><circle cx="8" cy="8" r="6" /><path d="M9.8 5.9c-.3-.6-1-1-1.8-1-1 0-1.8.6-1.8 1.4 0 1.8 3.7 1 3.7 2.9 0 .8-.8 1.4-1.9 1.4-.9 0-1.6-.4-1.9-1.1M8 3.9v1M8 11.1v1" /></>, 1.3);
/** O certame: o martelo do pregão. */
export const IconeMartelo = (p: Props) =>
  base(p, <><path d="m6.2 3.2 3.6 3.6M3.8 5.6l3.6 3.6M5 4.4l3.6 3.6" /><path d="m8.4 7.6 5 5" /><path d="M2.5 13.5h5" /></>, 1.4);
/** Fora do sistema, no portal: o globo. */
export const IconeGlobo = (p: Props) =>
  base(p, <><circle cx="8" cy="8" r="6" /><path d="M2.2 6.5h11.6M2.2 9.5h11.6M8 2c1.7 1.9 2.5 3.9 2.5 6S9.7 12.1 8 14C6.3 12.1 5.5 10.1 5.5 8S6.3 3.9 8 2Z" /></>, 1.3);
/** O que é nosso: o alvo. */
export const IconeAlvo = (p: Props) =>
  base(p, <><circle cx="8" cy="8" r="6" /><circle cx="8" cy="8" r="3" /><circle cx="8" cy="8" r=".6" /></>, 1.4);
/** Quem decidiu: a pessoa. */
export const IconePessoa = (p: Props) =>
  base(p, <><circle cx="8" cy="5.5" r="2.7" /><path d="M2.8 14c.6-2.6 2.7-4.2 5.2-4.2s4.6 1.6 5.2 4.2" /></>, 1.4);

/** Todos, pelo nome — é o que a página do design system lista. */
export const ICONES = {
  IconeLupa, IconeSeta, IconeVoltar, IconeChevron, IconeXis, IconeMais, IconeVisto, IconeFunil,
  IconeGrade, IconeLinhas, IconeLixeira, IconeInfo, IconeAlerta, IconeCadeado, IconeDocumento,
  IconeRelogio, IconeLocal, IconeMoeda, IconeMartelo, IconeGlobo, IconeAlvo, IconePessoa,
};
